import { v4 as uuid } from 'uuid';
import { Flux } from '../../flux';
import { IError } from '../../types';
import Gizmo from '../gizmo';

interface IParams {
  context: {
    flux: Flux;
    gizmo: Gizmo;
  };
}

/**
 * Run a local flux validation
 *
 * @returns {IValidationError[]} validation errors
 */
function localValidation({ context }: IParams): Promise<IError[]> {
  return new Promise<IError[]>(async resolve => {
    const { flux, gizmo } = context;
    const errors: IError[] = [];

    const config = gizmo.getConfig();

    if (
      config.ops?.localValidation?.flux &&
      config.ops.localValidation.errorMessage
    ) {
      const result = await flux.evaluate({
        script: config.ops.localValidation.flux,
      });
      let message = config.ops.localValidation.errorMessage;
      if (message.includes('{{')) {
        // This means it has influx variables so we have to solve them
        message = await flux.interpolate({ script: message });
      }

      if (result === false) {
        errors.push({
          fid: uuid(),
          code: 'local-validation',
          message,
        });
      }
    }

    resolve(errors);
  });
}

export default localValidation;
